/**
 * 用户状态管理Store
 * 使用Zustand管理全局用户状态，支持数据持久化
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Account } from '@/api/types/user.types'

/**
 * 用户状态接口定义
 */
interface UserState {
  /** 当前登录用户信息 */
  currentUser: Account | null

  /**
   * 设置用户信息
   * @param user 用户账号信息，null表示清除用户信息
   */
  setUser: (user: Account | null) => void

  /** 重置store到初始状态 */
  reset: () => void
}

/**
 * 初始状态
 */
const initialState = {
  currentUser: null,
}

/**
 * 用户状态Store
 * 支持本地存储持久化，刷新页面后用户状态会自动恢复
 */
export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      ...initialState,

      setUser: (user) => set({ currentUser: user }),

      reset: () => set(initialState),
    }),
    {
      name: 'user-store', // 本地存储的键名
      partialize: (state) => ({
        currentUser: state.currentUser,
      }), // 指定需要持久化的状态字段
    }
  )
)
